//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { SurchargeType } from './Enums';

export class PaymentSurchargeDisplayItem extends ItemBase {
    Amount: number | null = null;
    Type: SurchargeType = SurchargeType.None;

    constructor(initializer?: Partial<PaymentSurchargeDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PaymentSurchargeDisplayItem";
}
